import Ordini from "..";

const routes = [
{ name: "OrdiniListPage", path: "/ordini", component: Ordini.OrdiniListPage, meta: { title: "Ordini" }},

];
export default routes;
